import React from 'react';
import { useRouteData } from "./routeContext";
import { useLocation, matchRoutes } from 'react-router-dom';
export var AppContext = /*#__PURE__*/React.createContext({});
export function useAppData() {
  return React.useContext(AppContext);
}
export function useSelectedRoutes() {
  var location = useLocation();

  var _useAppData = useAppData(),
      clientRoutes = _useAppData.clientRoutes; // use `useLocation` get location without `basename`, not need `basename` param


  var routes = matchRoutes(clientRoutes, location.pathname);
  return routes || [];
}
export function useServerLoaderData() {
  var route = useRouteData();
  var appData = useAppData();
  return {
    data: appData.serverLoaderData[route.route.id]
  };
}
export function useClientLoaderData() {
  var route = useRouteData();
  var appData = useAppData();
  return {
    data: appData.clientLoaderData[route.route.id]
  };
}